import React from "react";
import { Container, Row, Col, Image} from "react-bootstrap";
// import { css } from "@emotion/core";
import "../css/testimonials.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import images
import reviewBox from '../img/review/review-box.svg';
import rating from '../img/review/5 star icon_4.9.png';

function Testimonials(props) {
    return(
        <React.Fragment>       
            <Container className="text-center text-white d-flex justify-content-center" fluid style={{backgroundColor: "rgb(8, 63, 136)"}}>
                <Row>
                    <Col className="py-1">
                        <h1 className="text-white">What People Are Saying</h1>
                    </Col>
                </Row>
            </Container>  
         
            <Container fluid className="pb-2 pb-md-5 multiImageBack">
                <Row>
                    <Col lg={12} className="d-flex justify-content-center align-items-center text-center py-3">
                        <h3 style={{verticalAlign: "middle"}}><Image fluid src={rating} alt="rating stars" style={{width:"50%"}} /> 1800+&nbsp;reviews</h3>
                    </Col>
                </Row>
                <Row className="testimonials-row justify-content-center">
                <Col lg={4} className="text-center widgetWrapper d-none d-sm-none d-md-none d-lg-block" style={{backgroundImage:`url(${reviewBox})`,backgroundSize: "contain",backgroundColor:"transparent",backgroundRepeat:"no-repeat",backgroundPosition:"center"}}>
                        <script type="text/javascript" src="https://birdeye.com/sun-west-mortgage-company-inc-nmls-id-3277-154827373198858"></script>
                        
                        <div id="bf-revz-widget-1234568011275" style={{WebkitOverflowScrolling: 'touch'}} className="responsive-iframe">
                        <iframe
  name="bfiframe"
  title="birdeye"
  className="reviewIcon"
  src="https://birdeye.com/widget/render.php?bid=154827373198858&wid=5&ver=4&update=0"
  id="bfpublish"
  scrolling="no"
  style={{ width: 270 }} // optional if you want width inline
  loading="lazy"
  sandbox="allow-scripts allow-same-origin"
  frameBorder={0}
/>                            
                        <div className="bf-dv d-none"><span className="bf-spn"> powered by <a className="bf-pwr" href="https://birdeye.com?utm_source=SRC&utm_medium=widget_review-feed&utm_campaign=birdeye_widget&utm_term=powered-by-birdeye&utm_content=rotating-widget_#51a8d3" rel="noopener noreferrer" target="_blank">BirdEye</a></span></div>
                        </div>
                    </Col>
                    <Col lg={4} className="text-center widgetWrapper" style={{backgroundImage:`url(${reviewBox})`,backgroundSize: "contain",backgroundColor:"transparent",backgroundRepeat:"no-repeat",backgroundPosition:"center"}}>
                    <script type="text/javascript" src="https://birdeye.com/embed/v4/154827373198858/8/1234567985183"></script>

                        <div id="bf-revz-widget-1234567985183" style={{WebkitOverflowScrolling: 'touch'}} className="responsive-iframe">
                            <iframe className="" name="bfiframe" src="https://birdeye.com/widget/render.php?bid=154827373198858&wid=8&ver=4&update=0" id="bfpublish" width={270} height={170} scrolling="no" frameBorder={0} title="Customer reviews" style={{borderWidth: '0px', display: 'block', margin: '0px auto', overflow: 'hidden'}} />
                            
                            <div className="bf-dv d-none"><span className="bf-spn"> powered by <a className="bf-pwr" href="https://birdeye.com?utm_source=SRC&utm_medium=widget_review-feed&utm_campaign=birdeye_widget&utm_term=powered-by-birdeye&utm_content=rotating-widget_#51a8d3" rel="noopener noreferrer" target="_blank">BirdEye</a></span></div></div>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}

export default Testimonials;